import { Alert } from '@accure/ui';

export type LoadErrorProps = {
  title: string;
};

export function LoadError({ title }: LoadErrorProps) {
  return (
    <div className="p-4">
      <Alert
        severity="error"
        className="m-auto border border-red-100 xl:max-w-4xl"
        title={title}
      >
        Please try again later, or contact ACCURE support if the problem
        persists.
      </Alert>
    </div>
  );
}
